import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GpsCoord } from 'src/app/models/core.model';

@Component({
  selector: 'app-visit-gps-modal',
  templateUrl: './visit-gps-modal.component.html',
  styleUrls: ['./visit-gps-modal.component.scss']
})
export class VisitGpsModalComponent implements OnInit {

  coords: GpsCoord[];
  center: GpsCoord = {lat: 0, lng: 0};

  constructor(public modalRef: BsModalRef, public modalService: BsModalService) { }

  ngOnInit() {
    this.center = {lat: this.mapCentreLat, lng: this.mapCentreLng};
  }

  get mapCentreLat() {
    return this.coords[0][0].lat;
  }

  get mapCentreLng() {
    return this.coords[0][0].lng;
  }
}
